import * as awsui from "@cloudscape-design/design-tokens";
import { Navbar, Dropdown } from "@nextui-org/react"; // https://nextui.org/docs/components/navbar
import { useEffect, useState, useContext, useCallback, useRef} from "react";
import { icons } from "./icons";
import { useMediaQuery } from 'react-responsive';
import { GlobalContext } from "../../context";
import { useNavigate, useLocation, Navigate, Link } from "react-router-dom";
import { withAuthenticator, Authenticator } from '@aws-amplify/ui-react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { navigateFn } from "../../routingHelper";


export default function SeriesNavLinks() {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const location = useLocation();
  const { 
    seriesContent, setSeriesContent,
  } = useContext(GlobalContext);
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const { route } = useAuthenticator(context => [context.route]); 
  const { authStatus } = useAuthenticator(context => [context.authStatus]);

  const reducedNavbar = useMediaQuery({query: "only screen and (max-width : 800px)"});

  const CustomSeriesLinks = () => {
    if (location.pathname === '/trinations-series') {
      return (
        <>
          <Navbar.Link css={{ color: awsui.colorTextBodyDefault }} isActive={seriesContent === "qualifying"} onClick={() => {setSeriesContent("qualifying")}}>Qualifying</Navbar.Link>
        </>
      )
    }
    return <></>
  }

  // const CustomSeriesDropdown = () => {
  //   if (location.pathname === '/trinations-series') {
  //     return (
  //       <Dropdown.Item key="qualifying">
  //         Qualifying
  //       </Dropdown.Item>
  //     )
  //   }
  // }

  const DropdownMenuItems = () => {
    const items = [{ label: "Series", key: "series"}]
    if (location.pathname === '/trinations-series') items.push({ label: "Qualifying", key: "qualifying"})
    items.push({ label: "Rules", key: "rules"})
    items.push({ label: "Gallery", key: "gallery"})

    return items.map(( item ) => 
      <Dropdown.Item key={item.key}>
        {item.label}
      </Dropdown.Item>
    )
  }


  if (!reducedNavbar) return (
    <>
      <Navbar.Link 
        css={{ 
          color: awsui.colorTextBodyDefault,
        }} 
        isActive={seriesContent === "series"} 
        onClick={() => {
          setSeriesContent("series")
        }} 
      >
          Series Info
      </Navbar.Link>
      <CustomSeriesLinks />
      {/* <Dropdown>
        <Navbar.Item>
          <Dropdown.Button
            auto
            light
            css={{
              px: 0,
              dflex: "center",
              svg: { pe: "none" },
              color: awsui.colorTextBodyDefault,
              marginRight: "0",
            }}
            iconRight={icons.chevron}
            ripple={false}
          >
            Results
          </Dropdown.Button>
        </Navbar.Item>
        <Dropdown.Menu
          aria-label="Series Menu"
          variant="shadow"
          css={{
            background: awsui.colorBackgroundDropdownItemDefault,
            $$dropdownMenuWidth: "340px",
            $$dropdownItemHeight: "70px",
            "& .nextui-dropdown-item": {
              py: "$4",
              // dropdown item title
              "& .nextui-dropdown-item-content": {
                w: "100%",
                fontWeight: "$semibold",
              },
              '&:hover': {
                background: "$primary",
              },
              '&:active': {
                background: "$primary",
              },
              '&:focus': {
                background: "$primary",
              },
            },
          }}
          onAction={(actionKey) => {
            navigate(actionKey.toString());
          }}
        >
          <Dropdown.Item
            key="f3a-series"
            // variant="shadow"
            showFullDescription
            description="ACME scales apps to meet user demand, automagically, based on load."
          >
            Season 1
          </Dropdown.Item>
          <Dropdown.Item
            key="f4a-series"
            // variant="shadow"
            showFullDescription
            description="Real-time metrics to debug issues. Slow query added? We’ll show you exactly where."
          >
            Season 2
          </Dropdown.Item>
          <Dropdown.Item
            key="ffa-series"
            // variant="shadow"
            showFullDescription
            description="ACME runs on ACME, join us and others serving requests at web scale."
          >
            Season 3
          </Dropdown.Item>
          <Dropdown.Item
            key="s5000-series"
            // variant="shadow"
            showFullDescription
            description="Applications stay on the grid with high availability and high uptime guarantees."
          >
            Season 4
          </Dropdown.Item>
          <Dropdown.Item
            key="fda-series"
            // variant="shadow"
            showFullDescription
            description="Overcome any challenge with a supporting team ready to respond."
          >
            Season 5
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <Navbar.Link css={{ color: awsui.colorTextBodyDefault }} isActive={location.pathname === "/news"} onClick={() => navigate("news")} href="">Calendar</Navbar.Link> */}
      <Navbar.Link css={{ color: awsui.colorTextBodyDefault }} isActive={seriesContent === "rules"} onClick={() => {setSeriesContent("rules")}}>Rules</Navbar.Link>
      {/* <Navbar.Link css={{ color: awsui.colorTextBodyDefault }} isActive={location.pathname === "/about"} onClick={() => navigate("about")} href="">Drivers and Teams</Navbar.Link>
      <Navbar.Link css={{ color: awsui.colorTextBodyDefault }} isActive={location.pathname === "/about"} onClick={() => navigate("about")} href="">Stats</Navbar.Link> */}
      <Navbar.Link css={{ color: awsui.colorTextBodyDefault }} isActive={seriesContent === "gallery"} onClick={() => {setSeriesContent("gallery")}}>Gallery</Navbar.Link>
      <Navbar.Link 
        css={{ 
          color: awsui.colorTextBodyDefault 
        }} 
        isActive={seriesContent === "register"} 
        onClick={() => {
          setSeriesContent("register")
          if (route !== 'authenticated') {
            navigate("/signin")
          }
        }}
      >
        Registration
      </Navbar.Link>
    </>
  );

  return (
    <>
    {/* <Navbar.Link css={{ color: awsui.colorTextBodyDefault }} isActive={seriesContent === "series"} onClick={() => {setSeriesContent("series")}}>Series Info</Navbar.Link> */}
      <Dropdown>
        <Navbar.Item>
          <Dropdown.Button
            auto
            light
            css={{
              px: 0,
              dflex: "center",
              svg: { pe: "none" },
              color: awsui.colorTextBodyDefault,
            }}
            iconRight={icons.chevron}
            ripple={false}
          >
            Series Info
          </Dropdown.Button>
        </Navbar.Item>
        <Dropdown.Menu
          aria-label="Series Menu"
          variant="shadow"
          css={{
            background: awsui.colorBackgroundDropdownItemDefault,
            $$dropdownMenuWidth: "340px",
            $$dropdownItemHeight: "70px",
            "& .nextui-dropdown-item": {
              py: "$4",
              // dropdown item title
              "& .nextui-dropdown-item-content": {
                w: "100%",
                fontWeight: "$semibold",
              },
              '&:hover': {
                background: "$primary",
              },
              '&:active': {
                background: "$primary",
              },
              '&:focus': {
                background: "$primary",
              },
            },
          }}
          onAction={( actionKey ) => {
            setSeriesContent(actionKey)
          }}
        >
          {DropdownMenuItems()}
          {/* <Dropdown.Item key="series">
            Series
          </Dropdown.Item>
          {CustomSeriesDropdown()}
          <Dropdown.Item key="rules">
            Rules
          </Dropdown.Item>
          <Dropdown.Item key="gallery">
            Gallery
          </Dropdown.Item> */}
        </Dropdown.Menu>
      </Dropdown>
      {/* <Dropdown>
        <Navbar.Item>
          <Dropdown.Button
            auto
            light
            css={{
              px: 0,
              dflex: "center",
              svg: { pe: "none" },
              color: awsui.colorTextBodyDefault,
            }}
            iconRight={icons.chevron}
            ripple={false}
          >
            Results
          </Dropdown.Button>
        </Navbar.Item>
        <Dropdown.Menu
          aria-label="Series Menu"
          variant="shadow"
          css={{
            background: awsui.colorBackgroundDropdownItemDefault,
            $$dropdownMenuWidth: "340px",
            $$dropdownItemHeight: "70px",
            "& .nextui-dropdown-item": {
              py: "$4",
              // dropdown item title
              "& .nextui-dropdown-item-content": {
                w: "100%",
                fontWeight: "$semibold",
              },
              '&:hover': {
                background: "$primary",
              },
              '&:active': {
                background: "$primary",
              },
              '&:focus': {
                background: "$primary",
              },
            },
          }}
          onAction={(actionKey) => {
            navigate(actionKey.toString());
          }}
        >
          <Dropdown.Item
            key="f3a-series"
            // variant="shadow"
            showFullDescription
            description="ACME scales apps to meet user demand, automagically, based on load."
          >
            Season 1
          </Dropdown.Item>
          <Dropdown.Item
            key="f4a-series"
            // variant="shadow"
            showFullDescription
            description="Real-time metrics to debug issues. Slow query added? We’ll show you exactly where."
          >
            Season 2
          </Dropdown.Item>
          <Dropdown.Item
            key="ffa-series"
            // variant="shadow"
            showFullDescription
            description="ACME runs on ACME, join us and others serving requests at web scale."
          >
            Season 3
          </Dropdown.Item>
          <Dropdown.Item
            key="s5000-series"
            // variant="shadow"
            showFullDescription
            description="Applications stay on the grid with high availability and high uptime guarantees."
          >
            Season 4
          </Dropdown.Item>
          <Dropdown.Item
            key="fda-series"
            // variant="shadow"
            showFullDescription
            description="Overcome any challenge with a supporting team ready to respond."
          >
            Season 5
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown> */}
      {/* <Navbar.Link css={{ color: awsui.colorTextBodyDefault }} isActive={seriesContent === "rules"} onClick={() => {setSeriesContent("rules")}}>Rules</Navbar.Link> */}
      <Navbar.Link 
        css={{ 
          color: awsui.colorTextBodyDefault 
        }} 
        isActive={seriesContent === "register"} 
        onClick={() => {
          setSeriesContent("register")
            if (route !== 'authenticated') {
              navigate("/signin")
          }
        }}
      >
        Register
      </Navbar.Link>
    </>
  )
}
